import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconSendLater: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSendLater"><Circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeDasharray="4 2"/><Circle cx="12" cy="12" r="7" stroke="currentColor"/><Path d="M12 8V12L15 15" stroke="currentColor"/></CentralIconBase>;
});

export default IconSendLater;
